import firebase from '../../lib/firebase.prod';
import * as PROJECT_CODE from '../../constants/projectCode';

// @desc return currentUser
export const signInApi = async (email, password, check) => {
	await firebase.auth().setPersistence(check === true ? 'local' : 'session');
	await firebase
		.auth()
		.signInWithEmailAndPassword(email, password)
		.then(() => {
			console.log('I am logged in');
		})
		.catch((error) => {
			throw error;
		});

	return firebase.auth().currentUser;
};

// @desc return current userType
export const getUserType = async () => {
	var currentUid = await firebase.auth().currentUser.uid;
	var currentUserType = '';

	await firebase
		.database()
		.ref('/users/' + currentUid)
		.once('value', function (snapshot) {
			let currentUser = snapshot.val();
			if (
				currentUser?.projectRoles &&
				currentUser.projectRoles[PROJECT_CODE.projectCode]
			) {
				currentUserType =
					currentUser.projectRoles[PROJECT_CODE.projectCode];
			}
		});

	return currentUserType;
};

export const signUpApi = async (email, password, fullName, telNumber) => {
	try {
		const result = await firebase
			.auth()
			.createUserWithEmailAndPassword(email, password);
		await result.user.updateProfile({
			displayName: fullName,
			phoneNumber: telNumber,
		});
		var currentUserId = firebase.auth().currentUser.uid;
		var userPost = firebase.database().ref('/users/' + currentUserId);

		userPost.set({
			email: email,
			phoneNumber: telNumber,
			fullName: fullName,
			displayName: fullName,
			avatarCode: 'undefined',
			project_code: PROJECT_CODE.projectCode,
			userType: 'client',
			projectRoles: {
				[PROJECT_CODE.projectCode]: 'client',
			},
			createdAt: new Date().getTime(),
		});

		return result.user;
	} catch (error) {
		throw error;
	}
};
